import { render } from "./branch-delete.vue?vue&type=template&id=c4ab8d3e"
import script from "./branch-delete.vue?vue&type=script&lang=js"
export * from "./branch-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__